import { render, staticRenderFns } from "./LocationData.vue?vue&type=template&id=25f01fc1"
import script from "./LocationData.vue?vue&type=script&lang=js"
export * from "./LocationData.vue?vue&type=script&lang=js"
import style0 from "./LocationData.vue?vue&type=style&index=0&id=25f01fc1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports